import preval from 'preval.macro';

import { BUILD_TIMESTAMP } from '../constants/localState';

// Store time at moment of build
const timestamp = preval`module.exports=new Date().getTime().toString();`;
const versionDate = preval`module.exports=()=>{a=new Date();p=(b)=>(b.toString().padStart(2,'0'));return p(a.getUTCDate())+'-'+p(a.getUTCMonth()+1)+'-'+a.getUTCFullYear();}`;
/** App version as provided as `VITE_VERSION` or the date this version was build */
const appVersion = import.meta.env.VITE_VERSION || versionDate;
/** App name as set in `package.json` (forwarded via `.env`) */
const appName = import.meta.env.VITE_NAME;

// Get previous build timestamp from storage
const prevTimestamp = localStorage.getItem(BUILD_TIMESTAMP);

// Check if the same or DO_NOT_CHECK_TIMESTAMP (used for E2E tests!)
// if no timestamp saved, it is probably the first load, so "same build"
const isSameBuild = !prevTimestamp || prevTimestamp === 'DO_NOT_CHECK_TIMESTAMP' || prevTimestamp === timestamp;

const isFirstLoad = !prevTimestamp;

// Set build to the same value
localStorage.setItem(BUILD_TIMESTAMP, timestamp);

export { timestamp, appVersion, appName, isSameBuild, isFirstLoad };
